import { forwardRef, type InputHTMLAttributes, type ReactNode } from "react";
import { cn } from "../lib/utils";

export const Toggle = forwardRef<HTMLInputElement, Omit<InputHTMLAttributes<HTMLInputElement>, "type"> & {
  label: ReactNode;
}>(({ label, className, ...props }, ref) => (
  <label className={cn("sqk-toggle", className)}>
    <input ref={ref} role="switch" type="checkbox" {...props} />
    <span aria-hidden="true" className="sqk-toggle__track"><span /></span>
    <span>{label}</span>
  </label>
));
Toggle.displayName = "Toggle";
